import { eventBus } from '@mtfe/sweet-utils';

const ResultReady = () => {
    eventBus.$emit('SearchResultReady');
};

export default ResultReady;
